<template>
  <div>
    <top />
    <div class="main home">
      <h1>关于我们</h1>
      <el-tabs tab-position="left">
        <!-- 公司简介 -->
        <el-tab-pane label="公司简介">
          <div class="content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>关于我们</el-breadcrumb-item>
              <el-breadcrumb-item>公司简介</el-breadcrumb-item>
            </el-breadcrumb>
            <div>
              <p>
                <!-- <strong>国务院发展研究中心信息网（简称“国研网”）</strong>创建于1998年3月，最初为国务院发展研究中心为更好地为中央提供应对1997年亚洲金融危机决策咨询建议，利用互联网、信息化手段所筹建的宏观经济网络信息平台。 -->
                <!-- <strong>北京国研网信息股份有限公司（简称“国研网”）</strong>成立于2001年4月，是国家高端智库国务院发展研究中心直属单位国研科技集团的下属企业，具有高新技术企业、质量管理体系和双软认证等多种企业资质证书，致力于成为国内一流的经济社会大数据及新型智库服务提供商。 -->
                <strong>北京国研网信息股份有限公司（简称“国研网”）</strong>成立于2001年4月，是国研科技集团的下属企业，具有高新技术企业、质量管理体系和双软认证等多种企业资质证书，致力于成为国内一流的经济社会大数据及新型智库服务提供商。
              </p>
              <div class="clearfix" style="margin-top:20px;">
                <img class="fl" src="@/assets/images/about/about1.png" alt />
                <img class="fr" src="@/assets/images/about/about2.png" alt />
              </div>
              <!-- <p>国研网创建20多年来，致力于与社会各界广泛深入合作，以“专业性、权威性、前瞻性、指导性和包容性”为原则，全力打造经济社会大数据服务、经济课题研究咨询和经济社会信息平台建设三大核心业务，为中国各级党政机关、研究机构和企事业单位提供研究及决策支持，为国家建设中国特色新型智库贡献力量。</p>
              <p>国研网具有高新技术企业、质量管理体系和双软认证等多种企业资质证书，并拥有一支高效专业、素质过硬、经验丰富的团队，80%以上的人员具有硕士以上学历，30%以上的人员具有海外学习背景。</p>
              <p>国研网将不忘初心，牢记使命，继续秉承强化管理、打造精品、用心服务的理念，不断开拓创新、锐意进取，努力成为国内一流的经济社会大数据及新型智库服务提供商。</p> -->
              <!-- <p>国研网创建20多年来，依托国务院发展研究中心权威的专家团队和国务院发展研究中心信息网丰富的信息资源，凭借先进的信息技术、专业的研发团队以及多年的服务经验，秉持“专业性、权威性、前瞻性、指导性和包容性”原则，全力打造经济社会大数据服务、经济课题研究咨询和经济社会信息平台建设三大核心业务，为中国各级党政机关、研究机构和企事业单位提供高质量的研究及决策支持服务，并赢得了各类用户的广泛赞誉。</p> -->
              <p>国研网创建20多年来，依托权威的专家团队和丰富的信息资源，凭借先进的信息技术、专业的研发团队以及多年的服务经验，秉持“专业性、权威性、前瞻性、指导性和包容性”原则，全力打造经济社会大数据服务、经济课题研究咨询和经济社会信息平台建设三大核心业务，为中国各级党政机关、研究机构和企事业单位提供高质量的研究及决策支持服务，并赢得了各类用户的广泛赞誉。</p>
              <p>未来，国研网将不忘初心，牢记使命，继续秉承强化管理、打造精品、用心服务的理念，不断开拓创新、锐意进取，努力为广大用户提供更加优质的信息服务，并为建设中国特色新型智库贡献更多力量。
              </p>
            </div>
          </div>
        </el-tab-pane>
        <!-- 发展愿景 -->
        <el-tab-pane label="发展愿景">
          <div class="content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>关于我们</el-breadcrumb-item>
              <el-breadcrumb-item>发展愿景</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="develop clearfix">
              <div class="fl">
                <p>国内一流的经济社会大数据及 新型智库服务提供商</p>
                <span>权威 / 专业 / 全面</span>
              </div>
              <img class="fl" src="@/assets/images/about/about3.png" />
            </div>
          </div>
        </el-tab-pane>
        <!-- 业务领域 -->
        <el-tab-pane label="业务领域">
          <div class="content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>关于我们</el-breadcrumb-item>
              <el-breadcrumb-item>业务领域</el-breadcrumb-item>
            </el-breadcrumb>
            <ul class="profession">
              <li>
                <h2>经济社会大数据服务</h2>
                <div class="info clearfix">
                  <img class="fl" src="@/assets/images/about/profession1.png" alt />
                  <div class="fr" style="position:relative;height:146px;">
                    <p>全面系统整合经济社会发展重点、热点领域文献及数据，建设高质量的数据库，通过在线数据库、本地镜像、数据包等形式，向用户提供权威专业的经济社会大数据服务；基于国研网自身内容运营的信息资源和专业经验积累优势，面向党政机关、企事业单位提供自媒体内容代运营服务；从事特定领域信息、舆情的监测服务。</p>
                    <router-link
                      :to="{path:'/product_service/data',query:{param:'大数据产品',child:'文献库'}}"
                    >查看详情</router-link>
                  </div>
                </div>
              </li>
              <li>
                <h2>经济课题研究咨询</h2>
                <div class="info clearfix">
                  <img class="fl" src="@/assets/images/about/profession2.png" alt />
                  <div class="fr" style="position:relative;height:146px;">
                    <p>针对用户的个性化研究需求，依托权威专家资源和专业研究队伍，围绕宏观、区域、产业等领域，提供形势分析、政策研究、发展规划等方面的课题研究咨询服务。</p>
                    <router-link
                      :to="{path:'/product_service/research',query:{param:'政策规划咨询'}}"
                    >查看详情</router-link>
                  </div>
                </div>
              </li>
              <li>
                <h2>经济社会信息平台建设</h2>
                <div class="info clearfix">
                  <img class="fl" src="@/assets/images/about/profession3.png" alt />
                  <div class="fr" style="position:relative;height:146px;">
                    <p>聚焦宏观、区域、产业经济领域，根据用户研究及决策需要，发挥国研网在信息内容、研究、技术上的综合优势，为各级政府、各类智库、企事业单位提供信息支撑平台建设以及运维服务。</p>
                    <router-link
                      :to="{path:'/product_service/infor',query:{param:'解决方案',child:'经济监测分析平台'}}"
                    >查看详情</router-link>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <!-- 核心优势 -->
        <el-tab-pane label="核心优势">
          <div class="content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>关于我们</el-breadcrumb-item>
              <el-breadcrumb-item>核心优势</el-breadcrumb-item>
            </el-breadcrumb>
            <ul class="core clearfix">
              <li v-for="item in core" :key="item.id">
                <img class="core-bg" :src="require(`@/assets/images/about/bg${item.id}.png`)" />
                <div class="cores">
                  <div class="title">{{item.title}}</div>
                  <p class="cores_info">{{item.content}}</p>
                </div>
              </li>
            </ul>
          </div>
        </el-tab-pane>
        <!-- 组织架构 -->
        <el-tab-pane label="组织架构">
          <div class="content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>关于我们</el-breadcrumb-item>
              <el-breadcrumb-item>组织架构</el-breadcrumb-item>
            </el-breadcrumb>
            <img class="organize" src="@/assets/images/about/organize.png" />
          </div>
        </el-tab-pane>
        <!-- 资质荣誉 -->
        <el-tab-pane label="资质荣誉">
          <div class="content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <span class="fl" style="line-height: 40px;margin-left:20px;">当前位置：</span>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>关于我们</el-breadcrumb-item>
              <el-breadcrumb-item>资质荣誉</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="homes tabcss textcss" id="ry">
              <div class="hgtop" style="margin-top: 0px;">
                <div class="ryibox">
                  <!-- <div class="titlery">领导关怀</div>
                  <div class="hgtop">
                    <div class="ldghimg">
                      <ul class="clearfix">
                        <li>
                          <img src="@/assets/imgs/ld1.png" />
                          <p>2004年1月时任曾培炎副总理视察公司</p>
                        </li>
                        <li>
                          <img src="@/assets/imgs/ld2.png" />
                          <p>2011年11月时任李克强副总理视察公司</p>
                        </li>
                        <li>
                          <img src="@/assets/imgs/ld3.png" />
                          <p>2013年3月时任张高丽副总理视察公司</p>
                        </li>
                      </ul>
                      <div class="clear"></div>
                    </div>
                  </div> -->
                  <!-- 企业资质 -->
                  <div class="titlery">企业资质</div>
                  <p style="font-size:16px;margin-top:20px;margin-bottom: 20px;">国研网具有高新技术企业、质量管理体系和双软认证等多种企业资质证书，并获得了权威机构颁发的多项荣誉证书。</p>
                  <div style="margin: 0 auto;width: 100%;"><p style="font-size:18px;text-align: center;font-weight: 700;">资质荣誉证书(部分)</p></div>
                  <div class="ryzz">
                    <ul class="ryul ryulw clearfix center">
                      <li>
                        <img src="@/assets/imgs/1-about.jpg" />
                        <h4 style="width: 91%;margin: 0 auto;">中华人民共和国增值电信业务经营许可证（ICP证书）</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/2-about.jpg" />
                        <h4 style="width: 91%;margin: 0 auto;">中华人民共和国增值电信业务经营许可证（SP证书）</h4>
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                  <div class="ryzz">
                    <ul class="ryul ryulw4 clearfix">
                      <li>
                        <img src="@/assets/imgs/3-about.jpg"  />
                        <h4>出版物经营许可证</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/newimg12.jpg" />
                        <h4>高新技术企业证书</h4>
                      </li>
                      
                      <li>
                        <img src="@/assets/imgs/newimg8.jpg" />
                        <h4 style="width:97%;margin:0 auto;">北京市“专精特新”中小企业证书</h4>
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                  <div class="ryzz">
                    <ul class="ryul ryulw clearfix">
                      <li>
                        <img src="@/assets/imgs/6-about.jpg"  />
                        <h4>信息安全管理体系认证证书</h4>
                      </li>
                      <li style="width:401px;margin-left:45px;margin-right:15px">
                        <img src="@/assets/imgs/7-about.jpg" />
                        <h4>GB/T19001-2016/ISO9001:2015质量管理体系认证证书</h4>
                      </li>
                      
                      <li>
                        <img src="@/assets/imgs/8-about.jpg" />
                        <h4 >ISO20000-1服务管理体系认证证书</h4>
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                  <div class="ryzz">
                    <ul class="ryul ryulw clearfix center">
                      <li>
                        <img src="@/assets/imgs/9-about.jpg" />
                        <h4>2022北京软件核心竞争力企业（创新型）</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/10-about.jpg" />
                        <h4 style="width:97%;margin:0 auto;">2018中国软件行业最具影响力企业</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/11-about.jpg" />
                        <h4 style="width:97%;margin:0 auto;">2017年中国最具影响力软件和信息服务企业</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/12-about.jpg" />
                        <h4 style="width:97%;margin:0 auto;">北京市共铸诚信企业</h4>
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                  <div class="ryzz">
                    <ul class="ryul ryulw4 clearfix">
                      <li>
                        <img src="@/assets/imgs/13-about.jpg"  />
                        <h4>企业信用AAA等级证书</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/14-about.jpg" />
                        <h4>2022年诚信系统集成企业证书</h4>
                      </li>
                      
                      <li>
                        <img src="@/assets/imgs/15-about.jpg" />
                        <h4 style="width:97%;margin:0 auto;">2020年北京市诚信创建企业证书<br/>（连续三年）</h4>
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                  <!-- 计算机软件著作权登记证书 -->
                  <div class="titlery">知识成果</div>
                  <p style="font-size:16px;margin-top:20px;margin-bottom: 20px;">国研网长期坚持自主研发，具有计算机软件著作权登记证书数十个，商标注册证6个。</p>
                  <div style="margin: 0 auto;width: 100%;"><p style="font-size:18px;text-align: center;font-weight: 700;">计算机软件著作权登记证书（部分）</p></div>
                  <div class="ryzz">
                    <ul class="ryul ryulw4 clearfix">
                      <li>
                        <img src="@/assets/imgs/16-about.jpg" />
                        <h4>“一带一路”研究与决策支撑平台</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/17-about.jpg" />
                        <h4>国研网系列研究报告平台</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/18-about.jpg" />
                        <h4>经济·管理案例库平台</h4>
                      </li>
                      
                    </ul>
                    <div class="clear"></div>
                  </div>
                  <div class="ryzz">
                    <ul class="ryul ryulw4 clearfix">
                      <li>
                        <img src="@/assets/imgs/19-about.jpg" />
                        <h4>国研网经济数据库教研支持系统</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/20-about.jpg" />
                        <h4>国研网政府管理决策支持系统</h4>
                      </li>
                      <li>
                        <img src="@/assets/imgs/21-about.jpg" />
                        <h4>国际贸易研究及决策支持系统</h4>
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                  <div style="margin-top: 60px;width: 100%;"><p style="font-size:18px;text-align: center;font-weight: 700;">商标注册证（部分）</p></div>

                  <div class="ryzz">
                    <ul class="ryul ryulw4 clearfix">
                      <li>
                        <img src="@/assets/imgs/22-about.jpg" />
                        
                      </li>
                      <li>
                        <img src="@/assets/imgs/23-about.jpg" />
                        
                      </li>
                      <li>
                        <img src="@/assets/imgs/24-about.jpg" />
                        
                      </li>
                    </ul>
                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <Footer />
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 核心优势
      core: [
        {
          id: 1,
          title: "智库背景",
          // //"国家顶级智库国务院发展研究中心下属单位，国研网为国务院发展研究中心窗口网站及其研究成果唯一授权网络发布渠道"
          // content:"国家高端智库国务院发展研究中心直属单位国研科技集团下属企业，依托国务院发展研究中心信息网（www.drcnet.com.cn）开展工作"
          content:"国研科技集团下属企业，依托国务院发展研究中心信息网（www.drcnet.com.cn）开展工作"
        },
        {
          id: 2,
          title: "专业团队",
          // content: "拥有包括国务院发展研究中心专家在内的强大专家顾问团队，并建立起了一支高效专业、素质过硬、经验丰富的研发团队"
          content: "拥有强大的专家顾问团队，并建立起了一支高效专业、素质过硬、经验丰富的研发团队"
        },
        {
          id: 3,
          title: "能力突出",
          content:
            "在经济社会大数据服务、经济课题研究咨询、经济社会信息平台建设和国家高端智库建设服务等方面能力突出"
        },
        {
          id: 4,
          title: "经验丰富",
          // "创建于1998年3月，拥有党政、教育、金融、企业机构用户800多家，连续多年成为全国两会指定服务机构，获得广大用户好评"
          content:"成立于2001年4月，拥有党政、教育、金融、企业机构用户800多家，连续多年成为全国两会指定服务机构，获得广大用户好评"
            
        },
        {
          id: 5,
          title: "实力雄厚",
          content:
            "具有质量管理体系认证、双软等认证和企业资质，获得系列计算机软件著作权登记证书、自主创新产品证书，是国家级高新技术企业"
        },
        {
          id: 6,
          title: "资源广泛",
          content:
            "与国内外众多政府部门、知名智库、企事业单位、行业协会、财经媒体建立起了良好的合作伙伴关系，具有广泛的信息资源来源渠道"
        }
      ]
    };
  }
};
</script>

<style lang='scss' scoped>
.main {
  position: relative;
  // 左侧导航
  h1 {
    width: 260px;
    height: 66px;
    background: #1967b6;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    line-height: 66px;
    position: absolute;
    top: 30px;
    text-align: left;
    padding: 0 30px;
  }
  /deep/.el-tabs__nav {
    width: 260px;
    background: #f4f6f7;
    .el-tabs__item {
      margin: 0 12px;
      height: 70px;
      line-height: 70px;
      text-align: left;
      font-size: 16px;
      color: #000;
    }
    .el-tabs__item + .el-tabs__item {
      border-top: 1px solid #e4e7e8;
    }
    .el-tabs__item.is-active {
      color: #1967b6;
      font-weight: bold;
    }
    .el-tabs__active-bar.is-left {
      background: #1967b6;
      height: 34px !important;
      top: 20px;
      left: 0;
    }
  }
  /deep/.el-tabs__header.is-left {
    margin-right: 52px;
    margin-top: 96px;
  }
  .content {
    margin: 30px 0 87px 0;
    .el-breadcrumb {
      background: #f3f5f7;
    }
    .el-breadcrumb__item {
      line-height: 40px;
    }
  }
  /deep/.el-tab-pane:nth-child(1) p {
    color: #000;
    line-height: 36px;
    margin-top: 40px;
    text-indent: 28px;
  }
  // 发展愿景
  .develop {
    p {
      width: 353px;
      font-size: 27px;
      font-family: FZLanTingHei-B-GBK;
      color: #202d3a;
      line-height: 58px;
      margin-top: 140px;
      margin-left: 51px;
    }
    span {
      display: block;
      width: 166px;
      height: 40px;
      background: linear-gradient(90deg, #328de2, #40bbd8);
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin-top: 54px;
      margin-left: 51px;
    }
    img {
      margin-top: 48px;
      margin-left: 42px;
    }
  }
  // 业务领域
  .profession {
    li {
      margin-top: 30px;
      h2 {
        display: inline-block;
        border-bottom: 2px solid #1967b6;
        font-size: 16px;
        font-weight: bold;
        color: #000000;
        line-height: 32px;
        padding: 0 5px;
      }
      .info {
        border-top: 1px solid #ebebeb;
        padding: 19px 0;
        img {
          margin-top: 0;
        }
        p {
          width: 504px;
          font-size: 14px;
          color: #000000;
          line-height: 24px;
        }
        a {
          display: block;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 99px;
          height: 32px;
          background: #ffffff;
          border: 1px solid #1967b6;
          font-size: 14px;
          color: #1967b6;
          line-height: 30px;
          text-align: center;
          cursor: pointer;
          &:hover {
            background: #1967b6;
            color: #fff;
          }
        }
      }
    }
  }
  // 核心优势
  .core {
    li {
      position: relative;
      width: 434px;
      height: 260px;
      background: #ffffff;
      // box-shadow: 0px 3px 7px 0px rgba(185, 185, 185, 0.35);
      float: left;
      margin-top: 43px;
      .core-bg {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 0;
      }
      .cores {
        width: 434px;
        height: 260px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        padding: 42px 45px;
        .title {
          border-bottom: 1px solid #e2e8ef;
          font-size: 16px;
          font-weight: bold;
          color: #1a1a1a;
          line-height: 38px;
        }
        .cores_info {
          font-size: 14px;
          color: #666666;
          line-height: 38px;
          margin-top: 14px;
        }
      }

      &:nth-child(2n) {
        float: right;
      }
    }
  }
  // 组织架构
  .organize {
    margin-top: 42px;
  }
  // 资质荣誉
  .titlery {
    text-align: left;
    font-size: 16px;
    color: #000;
    padding-top: 70px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 8px;
    font-weight: bold;
  }
  .grzzcss img {
    border-radius: 10px;
  }

  .grzzcss li img {
    height: 235px;
  }
  .hgtop {
    margin-top: 30px;
  }
  .ldghimg {
    margin-top: 50px;
    img {
      width: 280px;
      background-size: 100%;
    }
    li {
      float: left;
      border: 1px solid #eceef0;
      background: #fff;
      width: 280px;
      &:hover {
        box-shadow: 0px 5px 12px #e5e5e5;
        -moz-box-shadow: 0px 5px 12px #e5e5e5;
        -webkit-transition: all 0.2s linear;
        transition: all 0.2s linear;
        position: relative;
        top: -10px;
      }
      p {
        text-align: center;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
      }
    }
    li + li {
      margin-left: 20px;
    }
  }
  .ryzz .ryul li {
    float: left;
  }

  .ryulw li {
    width: 202px;
  }

  .ryzz li + li {
    margin-left: 25px;
  }

  .ryzz {
    margin-top: 50px;
  }

  .ryulw2 li {
    width: 157px;
  }

  .ryulw3 li {
    width: 383px;
  }
  .ryulw4 li {
    width: 280px;
  }

  .ryzz h4 {
    text-align: center;
    font-size: 14px;
    padding-top: 20px;
  }
  .w230 {
    width: 157px !important;
  }
  .w179 li {
    width: 201px;
  }
  .w155 li {
    width: 155px;
  }
  .w585 li {
    width: 425px;
  }
  .h257 img {
    height: 241px;
  }

  img {
    max-width: 100%;
  }
  h4 {
    font-weight: normal;
    color: #333;
    line-height: 160%;
  }
  .homes {
    width: 890px;
    margin: 0 auto;
  }
  .center {
    display: flex;
    justify-content: center;
  }
}
</style>